import Vue from 'vue'
import LayerVue from 'layer-vue'
import 'layer-vue/lib/index.css'
import KeenUI from 'keen-ui'
import 'keen-ui/dist/keen-ui.css'
import store from './store'
import Dialog from 'v-dialogs'
import { get, post, up } from './http/index'
import $ from 'jquery'
import VTooltip from 'v-tooltip'
import App from './App.vue'
import router from './router'

Vue.use(VTooltip)
Vue.use(Dialog, { language: 'en' })
Vue.use(LayerVue, {
  //此项设置置顶窗口的初始值，默认为100，一般无需配置，和其他组件冲突时可在此配置
  zIndex: 100,
  //全局配置窗口皮肤
  skin: {
    //具体参数参见配置项：skin
    background: 'transparent',
    boxShadow: '',
    title: {
      background: 'transparent',
      color: '#000',
      borderBottom: '1px solid #f0f0f0'
    },
    content: {
      background: 'transparent',
      color: '#000'
    },
    slider: {
      background: 'rgba(153, 153, 153, 0.5)'
    },
    shade: { background: 'rgba(0, 0, 0, 0.3)' },
    maxmin: {
      background: 'transparent',
      color: '#000',
      backgroundHover: '#6666',
      colorHover: '#008afc'
    },
    close: {
      background: 'transparent',
      color: '#000',
      backgroundHover: '#f00',
      colorHover: '#fff'
    }
  },
  //控制台打印相关信息
  log: true
})
Vue.use(KeenUI)
require('./utils')

//require('jquery-ui')

require('jquery.easing')
var jQueryBridget = require('jquery-bridget')
var Isotope = require('isotope-layout')
var imagesLoaded = require('imagesloaded')

jQueryBridget('isotope', Isotope, $)
jQueryBridget('imagesLoaded', imagesLoaded, $)


Vue.config.productionTip = false

Vue.prototype.$http = { get, post, up }
Vue.prototype.$G = { domain: 'http://www.mega-wine.com' }
Vue.prototype.$tips = {
  success: (msg) => ElementUI.Message({
    message: msg,
    type: 'success',
    duration: 3 * 1000
  }),
  warning: (msg) => ElementUI.Message({
    message: msg,
    type: 'warning',
    duration: 3 * 1000
  })
}
// router.afterEach((to, from, next) => {
//   window.scrollTo(0, 0)
// })

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
